import {
  Box,
  Card,
  Flex,
  IconBadge,
  IconCheck,
  Text,
  TextAction,
} from '@coverflex-tech/hypernova';

type TCardFilePreviewProps = {
  title?: string;
  fileName: string;
  fileBlob?: Blob;
  fileURL?: string;
};

export const CardFilePreview = ({
  title,
  fileName,
  fileBlob,
  fileURL,
}: TCardFilePreviewProps) => {
  return (
    <Card key={fileName} plain>
      <Box padding={'md'}>
        <Flex alignItems="center" gap="md">
          <IconBadge
            icon={<IconCheck themeColor={'neutral10'} />}
            ratio={40}
            backgroundColor={'systemSuccess20'}
          ></IconBadge>
          <Flex flexDirection="column">
            {title && <Text bold>{title}</Text>}
            <TextAction
              href={
                fileURL || (fileBlob && URL.createObjectURL(fileBlob)) || '#'
              }
              target="_blank"
            >
              <Text size="sm" color={'neutral20'}>
                {fileName}
              </Text>
            </TextAction>
          </Flex>
        </Flex>
      </Box>
    </Card>
  );
};
